// extracted by mini-css-extract-plugin
export default {"colors":"accent,neutral,negative,warning,positive","icon":"styles_icon__hcgge"};